(() => {
  const updateSlide = (slide) => {
    const hidden = slide.getAttribute('aria-hidden') === 'true';
    slide.inert = hidden;
  };

  const initialiseSlides = (root = document) => {
    root.querySelectorAll('.splide__slide[aria-hidden]').forEach(updateSlide);
  };

  initialiseSlides();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.target.matches('.splide__slide')) updateSlide(mutation.target);
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches('.splide__slide[aria-hidden]')) updateSlide(node);
        initialiseSlides(node);
      });
    });
  });
  observer.observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden'] });

  document.addEventListener('shopify:section:load', (event) => {
    initialiseSlides(event.target);
  });
})();
